export default __webpack_public_path__ + "81e32e6c1975ac79f9ae8aa0a752d088.ttf";